export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4f17a0c958dbf87f669570022fb1efe1f895002a&name=fetchTypeahead!'